import React from 'react'
import { Link } from 'react-router-dom'

const HomepageCategoriesLeftContainer = ({ containerObject, templateName, contentId, dataZone }) => {
   
    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row gx-0 ${containerObject?.enableContentVisibilityAttribute === "N" ?  '':'content-visibility-class'}`}>
            <div className='d-none d-md-block c-category-left-nav left-menu '>
                <div className={`c-shop-top-category ${'cb-top-' + (containerObject?.attributes?.menuName?.split(' ')[0]?.toLowerCase() ?? "")}`}>
                    <h3 className="h4 mb-0 mt-2 pb-1">{containerObject?.attributes?.menuName ?? ""}</h3>
                    <ul className="list-group">
                        {
                            containerObject?.tabs && containerObject?.tabs.map((tab, index) => (
                                <li key={tab?.contentId ? tab.contentId : index} className="left-menu-group-item">
                                    {tab?.attributes?.link && tab.attributes.link.includes("https") ? 
                                    <a target={tab?.attributes?.isTargetBlank === "Y" ? "_blank" : ""} class={`left-menu-item ${tab?.svg?.length === 0 && tab?.attributes?.imageLink?.length === 0 ? "no-icon" : ""}`} href={tab?.attributes?.link ? tab.attributes.link : "#"}>
                                        {tab?.svg?.length > 0 ? (<i class="icon-svg-cust">
                                            <div dangerouslySetInnerHTML={{ __html: tab.svg }} />
                                        </i>) : (tab?.attributes?.imageLink?.length > 0 ? (<i class="icon-svg-cust">
                                            <img class='img-icon' src={tab?.attributes?.imageLink ?? ""} />
                                        </i>) : (tab?.uploadIamge?.length > 0 && <i class="icon-svg-cust">
                                            <img class='img-icon' src={tab?.uploadIamge ?? ""} />
                                        </i>))
                                        }
                                        {tab?.attributes?.displayName ?? ""}
                                        <i className="bi bi-chevron-right d-block d-md-none float-end"></i>
                                    </a> :
                                    <Link target={tab?.attributes?.isTargetBlank === "Y" ? "_blank" : ""} className={`left-menu-item ${tab?.svg?.length === 0 && tab?.attributes?.imageLink?.length === 0 ? "no-icon" : ""}`} to={tab?.attributes?.link ? tab.attributes.link : "#"}>
                                        {tab?.svg?.length > 0 ? (<i className="icon-svg-cust">
                                            <div dangerouslySetInnerHTML={{ __html: tab.svg }} />
                                        </i>) : (tab?.attributes?.imageLink?.length > 0 ? (<i className="icon-svg-cust">
                                            <img className='img-icon' src={tab?.attributes?.imageLink ?? ""} />
                                        </i>) : (tab?.uploadIamge?.length > 0 && <i className="icon-svg-cust">
                                            <img className='img-icon' src={tab?.uploadIamge ?? ""} />
                                        </i>))
                                        }
                                        {tab?.attributes?.displayName ?? ""}
                                        <i className="bi bi-chevron-right d-block d-md-none float-end"></i>
                                    </Link> }
                                </li>
                            ))
                        }
                    </ul>

                </div>
            </div>
        </div>
    )
}

export default HomepageCategoriesLeftContainer